<div class="row country-rank-table">
  <ng-container *ngFor="let ranking of rankings">
    <div class=" col-lg-6 mb-4">
      <h5 class="sub-title">
        {{ranking?.title}}
        <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
          data-animation="false" title="{{ranking?.tooltip}}">
          <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
        </a>
      </h5>
      <div class="divider height-2px"></div>

      <ng-container *ngIf="desktop$ | async">
        <ng-container *ngFor="let country of ranking?.countries; let i = index;">
          <ng-container *ngIf=" ranking.showMore ? i < limit : true">
            <div class="d-flex align-items-center">
              <ng-container *ngIf="isFreemium">
                <div class="col-2 country-rank">
                  <div class='freemium-lock mr-1'>
                    <i class='fa fa-lock'></i>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="!isFreemium">
                <div class="col-2 country-rank">{{country.rank}}</div>
                <div class="country-rank-change">
                  <div class="change-number" [ngClass]="{increase: country.rankChange > 0,
                    decrease: country.rankChange < 0,
                    'no-change': country.rankChange === '0' || country.rankChange === 'N/A'}">
                    <span>{{country.rankChange | absolute}}&nbsp;</span>
                    <span class="change-icon">
                      <i class="fa fa-minus"></i>
                      <i class="fa fa-arrow-up"></i>
                      <i class="fa fa-arrow-down"></i>
                    </span>
                  </div>
                </div>
              </ng-container>
              <div>
                <a href="javascript:void(0)" (click)="navigateRankings(ranking?.rankingType, country.countryCode)">
                  <div class="d-flex align-items-center">
                    <img class="mr-2" src="https://cdn.pixalate.com/icons/countries/flat/48/{{country.countryCode}}.png"
                      alt="{{country.countryCode}} Flag Icon" />
                    <div>{{country.countryName}}</div>
                  </div>
                </a>
              </div>
            </div>
            <div class="divider"></div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="ranking?.countries?.length > 10">
          <button class="btn btn-block btn-outline-secondary text-gray-dark mt-2" (click)="toggleShowMore(ranking)">
            {{ ranking.showMore ? 'Show More' : 'Show Less' }}
          </button>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="tablet$ | async">
        <div style="max-height: 200px;" [ngStyle]="{ height: (ranking?.countries?.length) + '00px'}">
          <swiper #swiper style="height: 100%;"
            slidesPerView="{{ranking?.countries?.length < 5 ? ranking?.countries?.length : '4.5'}}" direction="vertical"
            scrollbar="true" [spaceBetween]="0">
            <ng-template swiperSlide *ngFor="let country of ranking?.countries; let i = index;">
              <div>
                <div class="d-flex align-items-center">
                  <ng-container *ngIf="isFreemium">
                    <div class="col-2 country-rank">
                      <div class='freemium-lock mr-1'>
                        <i class='fa fa-lock'></i>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!isFreemium">
                    <div class="col-2 country-rank">{{country.rank}}</div>
                    <div class="country-rank-change">
                      <div class="change-number" [ngClass]="{increase: country.rankChange > 0,
                  decrease: country.rankChange < 0,
                  'no-change': country.rankChange === '0' || country.rankChange === 'N/A'}">
                        <span>{{country.rankChange | absolute}}&nbsp;</span>
                        <span class="change-icon">
                          <i class="fa fa-minus"></i>
                          <i class="fa fa-arrow-up"></i>
                          <i class="fa fa-arrow-down"></i>
                        </span>
                      </div>
                    </div>
                  </ng-container>
                  <div>
                    <a href="javascript:void(0)" (click)="navigateRankings(ranking?.rankingType, country.countryCode)">
                      <div class="d-flex align-items-center">
                        <img class="mr-2"
                          src="https://cdn.pixalate.com/icons/countries/flat/48/{{country.countryCode}}.png"
                          alt="{{country.countryCode}} Flag Icon" />
                        <div>{{country.countryName}}</div>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="divider"></div>
              </div>
            </ng-template>
          </swiper>
        </div>
        <div class="d-flex justify-content-between" *ngIf="ranking?.countries?.length > 5">
          <button class="btn btn-primary py-2 mr-2 rounded-circle"
            [ngClass]="{ 'invisible disabled': swiper?.swiperRef?.isBeginning }" (click)="swiper.swiperRef.slidePrev()">
            <i class="fa fa-long-arrow-up"></i>
          </button>
          <button class="btn btn-primary py-2 rounded-circle"
            [ngClass]="{ 'invisible disabled': swiper?.swiperRef?.isEnd }" (click)="swiper.swiperRef.slideNext()">
            <i class="fa fa-long-arrow-down"></i>
          </button>
        </div>

      </ng-container>
    </div>
  </ng-container>
</div>